import type { ComponentProps, FC } from "react";

import { Suggestion } from "@/components/ai-elements/suggestion";
import { cn } from "@/lib/utils";

/** A prompt suggestion as a rectangular chip (like the IDE header chips), not a pill. */
export const PromptChip: FC<ComponentProps<typeof Suggestion>> = ({
  className,
  ...props
}) => (
  <Suggestion
    {...props}
    className={cn(
      "h-7 max-w-72 gap-1.5 rounded-sm border-border bg-background px-2.5 text-xs font-normal text-foreground hover:bg-muted",
      className
    )}
  />
);
